<div class="card">
  <div class="card-header">
    <h4>Grievances</h4>
    <div style="margin-top: 20PX;display: inline-flex;">
      <div *ngIf="!active" class="text-danger mt-1">
        <button   class="btn bg-danger-custom" type="button"  style="color:black" (click)="onSearchmerchant()" ><i
          class="feather icon-search me-2"></i>Merchant Greivance
     </button>         </div>
     <div *ngIf="active" class="text-danger mt-1">
      <button   type="button"  style="color:white"  class="btn bg-danger-custom" (click)="onSearchmerchant()" ><i
        class="feather icon-search me-2"></i>Merchant Greivance
   </button>         </div>
   <div *ngIf="!inactive" class="text-danger mt-1">
    <button   type="button"  style="color:black"  class="btn bg-danger-custom" (click)="onSearchCustomer()" ><i
      class="feather icon-search me-2"></i>Customer Greivance
 </button>         </div>
   <div *ngIf="inactive" class="text-danger mt-1">
    <button   type="button"  style="color:white"   class="btn bg-danger-custom" (click)="onSearchCustomer()" ><i
      class="feather icon-search me-2"></i>Customer Greivance
 </button>         </div>
 <!-- <button type="button"  style="color:white"   (click)="onSearchCustomer()" ><i
  class="feather icon-search"></i>Customer Greivance
</button>
  <button [ngClass]="{'btn bg-danger-custom':inactive, 'btn btn-success':!inactive}" type="button"  style="color:white"   (click)="onSearchCustomer()" ><i
     class="feather icon-search"></i>Customer Greivance
</button> -->
    </div>
  </div>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-xl-12">
        <!-- Filter Accordion -->
              <div class="row">
                <div class="col-md-4">
                  <label class="col-form-label" for="resellerPartnerId">Status</label>
                  <ng-select #filStatus [items]="merchantStatusdata" bindLabel="FieldText" bindValue="FieldValue"
                    [(ngModel)]="Status" placeholder="Select Status" required [inputAttrs]="{maxlength: '40'}" id="Status"
                    (focus)="fun('Status')" (focusout)="funover('Status')"  (change)="ondataSearch($event)">
                  </ng-select>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-form-label" for="searchMID">Search by Date Range</label>
                    <div class="col-md-6">
                      <input #filSearchFromDate [(ngModel)]="searchFromDate" class="form-control" id="searchFromDate"
                        max="{{searchToDate|date:'yyyy-MM-dd'}}" (change)="changeDate()" type="date" />
                    </div>
                    <div class="col-md-6">
                      <input #filSearchToDate [(ngModel)]="searchToDate" class="form-control" id="searchToDate"
                        min="{{searchFromDate|date:'yyyy-MM-dd'}}" (change)="changeEndDate()" type="date" />
                    </div>
                    <div *ngIf="!merchantdis" class="text-danger mt-1">
                      Please select Date !
                    </div>
                  </div>
                </div>
                <div class="col-sm-3 d-flex align-items-end">
                  <!-- <div class="row"> -->
                  <!-- <div class="col-md-12"> -->
                  <!-- <label class="col-form-label" for="searchMID">Search</label> -->
                  <!-- </div>            -->
                  <!-- <div class="col-md-6"> -->
                  <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom me-2" type="button" style="width: 100%;">
                    <i class="feather icon-search me-2"></i>Search
                  </button>
                  <!-- </div> -->
                </div>
              </div>
         
      </div>
    </div>
  </div>
    <div class="row" style="min-height: 300px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
        <ag-grid-angular [enableCellTextSelection]=true  (filterModified)="onFilterModified($event)"
          (gridReady)="onGridReady($event)"
          [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"   (rowDoubleClicked)="onRowDoubleClicked($event)"
          [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
          [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
          style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>
    <div class="row bg-white p-2 mt-0">
    <div class="col-md-4">
      <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
        class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="30">30</option>
      </select>
    </div>
    <div class="col-md-8">
      <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
        [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
        class="d-flex justify-content-end col-8 align-right">
      </ngb-pagination>
    </div>